import * as React from "react";

import { Resources, useResource } from "Translations/Resources";

import { DocumentDto } from "Api/Api";
import { PrimaryLink } from "Components/Shared/Routes/PrimaryLink";
import { StyledFlex } from "Components/Shared/StyledComponents";
import { Typography } from "@material-ui/core";
import { getDocumentIcon } from "Components/Shared/Documents/EditDocuments";
import { isEmptyArray } from "Utils/ArrayUtils";
import styled from "styled-components";

type Props = {
  documents: DocumentDto[];
  title: string;
};

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledDoc = styled(StyledFlex)`
  margin-bottom: ${props => props.theme.spacing(1)}px;

  & > div {
    margin-left: ${props => props.theme.spacing(2)}px;
  }
`;

export const Documents: React.FunctionComponent<Props> = props => {
  const { documents, title } = props;
  const { t } = useResource();

  return (
    <>
      {!isEmptyArray(documents) && (
        <>
          <StyledWrapper className={"row"}>
            <div className={"row-title"}>{title}</div>
            <div>
              {documents?.map(doc => (
                <StyledDoc key={doc.documentID} alignItems={"center"}>
                  {getDocumentIcon(doc.url)}
                  <div>
                    <Typography>{doc.name}</Typography>
                    <PrimaryLink
                      link={doc.url}
                      text={t(Resources.Common.Documents.Show)}
                    />
                  </div>
                </StyledDoc>
              ))}
            </div>
          </StyledWrapper>
          <hr />
        </>
      )}
    </>
  );
};
